import { getNotViewedOrders } from "services"
import * as types from "../types/notViewedOrders"

export const incNumberOfOrders = (orderStatus, number) => ({
  type: types.INC_NUMBER_OF_ORDERS,
  number,
  orderStatus
})

export const resetNotViewedOrders = (orderStatus) => ({
  type: types.RESET_NOT_VIEWED_ORDERS,
  orderStatus
})

export const fetchNotViewedOrders = (query) => (
  async (dispatch) => {
    try {
      const notViewedOrders =
        await getNotViewedOrders(query)

      dispatch({
        type: types.FETCH_NOT_VIEWED_ORDERS,
        data: {
          notViewedOrders: {
            notConfirmed: notViewedOrders.notConfirmed || 0,
            pending: notViewedOrders.pending || 0,
            paid: notViewedOrders.paid || 0,
            canceled: notViewedOrders.canceled || 0,
            delivered: notViewedOrders.delivered || 0
          }
        }
      })
    } catch (err) {
      console.log(err)
    }
  }
)